import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { type FC, type PropsWithChildren, useEffect } from "react";

import {
	GlobalResources,
	useResource,
} from "Infrastructure/Translations/Resources";
import { Footer } from "Shared/Components/Footer";
import { Header } from "Shared/Components/Header";

type Props = {
	title: string;
	showTitleInHeader?: boolean;
};

const LayoutContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background-color: #FAFAFA;
`;

const MainContent = styled(Box)`
	flex: 1;
	padding: ${(props) => props.theme.spacing(1.5)} ${(props) => props.theme.spacing(3)};
	background-color: #FAFAFA;
`;

export const MainLayout: FC<PropsWithChildren<Props>> = ({
	title,
	showTitleInHeader,
	children,
}) => {
	const { t } = useResource();

	useEffect(() => {
		document.title = `${title} | ${t(GlobalResources.Common.AppName)}`;
	}, [title, t]);

	return (
		<LayoutContainer>
			<Header title={showTitleInHeader ? title : undefined} />
			<MainContent>{children}</MainContent>
			<Footer />
		</LayoutContainer>
	);
};
